import { MagicWand } from "@phosphor-icons/react";
import { BooleanField } from "react-admin";

export const AiStatusField = (props) => {
  return (
    <BooleanField looseValue TrueIcon={MagicWand} FalseIcon={null} {...props} />
  );
};
